/* global wx */

import React, {useState, useEffect} from 'react'
import {Alert, Spin} from 'antd'
import { withRouter } from 'react-router-dom'
import {useAsyncEffect} from '@/utils/hooks'
import {ajaxApi, ajaxApiGet} from '@/server'
import common from '@/public/common'
import {compareVersion} from '@/public/utils'
import {invokeWx} from './utils'
import { getParmUrl } from '../../public/utils'

const WxworkEntry = ({history}) => {
  const [errorInfo, setErrorInfo] = useState(null)
  const [wxInitialized, setWxInitialized] = useState(false)

  useEffect(() => {
    const pageUrl = window.location.href
    if (pageUrl.indexOf('mobilepage') === -1) {
      window.location.href = `${pageUrl}${pageUrl.includes('?') ? '&' : '?'}mobilepage`
      return
    }
    // Mozilla/5.0 (Windows NT 6.2; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/53.0.2785.116 Safari/537.36
    // QBCore/4.0.1326.400 QQBrowser/9.0.2524.400 Mozilla/5.0 (Windows NT 10.0; WOW64)
    // AppleWebKit/537.36 (KHTML, like Gecko) Chrome/53.0.2785.116 Safari/537.36
    // wxwork/3.1.7 (MicroMessenger/6.2) WindowsWechat
    const matchRes = navigator.userAgent.toLowerCase().match(/\bwxwork\/([\d.]+)\b/)
    if (matchRes) {
      if (compareVersion(matchRes[1], '3.0.24') === -1) {
        setErrorInfo('您的企微版本过低，请升级至3.0.24以上')
        return
      }
    } else {
      setErrorInfo('该页面仅支持从企微单聊会话的侧边工具栏打开')
      return
    }

    // 引入微信公众号网页jssdk
    const scriptWx = document.createElement('script')
    scriptWx.src = '//res.wx.qq.com/open/js/jweixin-1.2.0.js'

    // 引入jwxwork sdk
    const scriptWxwork = document.createElement('script')
    scriptWxwork.src = '//open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js'
    scriptWxwork.onload = async () => {
      if (typeof wx.agentConfig !== 'function') {
        setErrorInfo('该页面仅支持在企微中打开')
        return
      }

      try {
        const brandId = getParmUrl('brandId')
        const {status, data} = await ajaxApi(`${common.javaBase_url}brandwx/enterprisewx/getsdk`, {
          url: window.location.href.split('#')[0],
          brandId: brandId,
          agentCode: 'SIDE'
        }, () => {}, common.noLoginToken)
        if (status !== 200 || !data) {
          setErrorInfo('获取签名数据失败')
          return
        }
        const config = {
          corpid: data.appId,
          agentid: data.agentId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ['getContext', 'getCurExternalContact'],
          success: () => {
            setWxInitialized(true)
          },
          fail: res => {
            console.error(res)
            setErrorInfo(`wxJSApi 初始化失败(${res.err_msg || JSON.stringify(res)})`)
          }
        }
        // console.log(config)
        // eslint-disable-next-line no-undef
        wx.agentConfig(config)
      } catch (e) {
        setErrorInfo(e.message)
        console.error(e)
      }
    }

    scriptWx.onload = () => {
      document.body.appendChild(scriptWxwork)
    }
    document.body.appendChild(scriptWx)
  }, [])

  useAsyncEffect(async () => {
    if (!wxInitialized) {
      return
    }
    try {
      const res1 = await invokeWx('getContext')
      if (res1.entry !== 'single_chat_tools') {
        setErrorInfo('该页面仅支持从企微单聊会话的侧边工具栏打开')
        return
      }
      const brandId = getParmUrl('brandId')
      const res2 = await invokeWx('getCurExternalContact')
      const {status, data} = await ajaxApi(`${common.javaBase_url}brandwx/enterprisewx/getunionid`, { externalUserId: res2.userId, brandId }, () => {}, common.noLoginToken)
      if (status !== 200) {
        setErrorInfo('获取用户关联信息失败')
        return
      }
      if (!data) {
        setErrorInfo('未获取到该外部用户的关联信息')
        return
      }
      const unionId = typeof data === 'object' ? data.unionId : data
      history.replace(`udeskSide?unionId=${unionId}&mobilepage=1&brandId=${brandId}`)
    } catch (e) {
      setErrorInfo(e.message)
      console.error(e)
    }
  }, [wxInitialized])

  return (
    <div>
      {
        !errorInfo
          ? <Spin size="large" style={{ width: '100%', margin: '84px auto' }} />
          : <Alert
            banner
            message="温馨提示"
            description={errorInfo}
            type="warning"
          />
      }
    </div>
  )
}

export default withRouter(WxworkEntry)



// WEBPACK FOOTER //
// ./src/pages/udeskSide/wxworkEntry.js